import { useMemo } from 'react'

import openReturnUtils from '@lib/openReturn'
import {
  checkIsDailyPassTicket,
  checkIsLimitedOneTimeUseTicket,
} from '@pages/Checkout/BookingDetails/TripDetails/ConnectionDetails/utils'
import { useSettings } from '@queries/settings'

export const useTripTypes = (fareClass?: FareClass) => {
  const [{ openReturn }] = useSettings()

  const isOpenReturnTrip = useMemo(
    () => Boolean(openReturn.enabled && fareClass && openReturnUtils.isOpenReturnFareClass(fareClass)),
    [openReturn.enabled, fareClass],
  )

  const isLimitedOneTimeTrip = useMemo(
    () => Boolean(fareClass && checkIsLimitedOneTimeUseTicket(fareClass)),
    [fareClass],
  )

  const isDailyPassTrip = useMemo(() => checkIsDailyPassTicket(fareClass), [fareClass])

  return { isOpenReturnTrip, isLimitedOneTimeTrip, isDailyPassTrip }
}
